import React from "react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import logoIcon from "@/assets/regard-de-nature-logo.png";
import { FileText } from "lucide-react";
import { BRAND } from "@/config/brand";

export const LegalNotice = () => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button className="hover:text-primary transition-colors text-left">Mentions légales</button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-2xl">
        <SheetHeader className="space-y-4 pb-6 border-b">
          <div className="flex flex-col items-center gap-3">
            <img src={logoIcon} alt={BRAND.name.full} className="w-16 h-16" />
            <div className="text-center">
              <SheetTitle className="text-3xl font-cinzel text-primary">{BRAND.name.full}</SheetTitle>
              <p className="text-sm font-montserrat font-semibold text-secondary uppercase tracking-wider mt-1">
                {BRAND.baseline.full}
              </p>
            </div>
          </div>
          <SheetDescription className="text-center text-lg font-medium text-foreground flex items-center justify-center gap-2">
            <FileText className="w-5 h-5 text-primary" />
            Mentions Légales
          </SheetDescription>
        </SheetHeader>

        <ScrollArea className="h-[calc(100vh-260px)] mt-6 pr-4 pb-12">
          <div className="space-y-6 text-sm">
            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">ÉDITEUR DU SITE</h3>
              <div className="space-y-2 text-muted-foreground">
                <p className="font-medium text-foreground">Laura ELIE</p>
                <p>Adresse : 31 rue de l'ancien petit fossé, 31450 Montesquieu-Lauragais</p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
                HÉBERGEMENT DU SITE
              </h3>
              <div className="space-y-2 text-muted-foreground">
                <p className="font-medium text-foreground">Société : OVHcloud SAS</p>
                <p>Adresse : 2 rue Kellermann, 59100 Roubaix, France</p>
                <p>Site : https://www.ovhcloud.com</p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">CONTACT</h3>
              <div className="space-y-2 text-muted-foreground">
                <p>
                  <span className="font-medium text-foreground">Téléphone :</span> +33 (0)6 37 03 18 66
                </p>
                <p>
                  <span className="font-medium text-foreground">Courriel :</span> Contact@regard-de-nature.fr
                </p>
                <p>
                  <span className="font-medium text-foreground">Courrier :</span> 31 rue de l'ancien petit fossé, 31450
                  Montesquieu-Lauragais
                </p>
              </div>
            </section>
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};
